import { Hero } from "@/components/hero"
import { HowItWorks } from "@/components/how-it-works"
import { ServiceCategories } from "@/components/service-categories"
import { KeyFeatures } from "@/components/key-features"
import { WhyChoose } from "@/components/why-choose"
import { AppShowcase } from "@/components/app-showcase"
import { CTA } from "@/components/cta"
import { Footer } from "@/components/footer"
import { SEO } from "@/components/SEO"

export default function HomePage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "MobileApplication",
    name: "StayApp",
    applicationCategory: "LifestyleApplication",
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.8",
      ratingCount: "15420",
    },
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
    operatingSystem: "iOS, Android",
    description:
      "Book accommodation, safari adventures, restaurants, nightlife, beauty services, and car hire with negotiable pricing. All in one app.",
  }

  return (
    <>
      <SEO
        title="StayApp - Book Your Stay, Your Way | Multi-Service Booking Platform"
        description="Book accommodation, safari adventures, restaurants, nightlife, beauty services, and car hire with negotiable pricing. All your travel and lifestyle needs in one app."
        keywords="accommodation booking, safari trips, restaurant reservations, nightlife booking, beauty services, car hire, negotiable pricing, travel booking app, lifestyle services, hotel booking, wellness booking"
        ogImage="/logo.png"
        ogUrl="https://stayapp.com"
        canonical="https://stayapp.com"
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <main className="pt-28 md:pt-36 lg:pt-40">
        <Hero />
        <HowItWorks />
        <ServiceCategories />
        <KeyFeatures />
        <WhyChoose />
        <AppShowcase />
        <CTA />
        <Footer />
      </main>
    </>
  )
}

